module.exports = __webpack_public_path__ + "static/media/slide2.5091e24d.jpg";